import React from "react";

export function CommonInput({ 
    label, 
    type, 
    name, 
    value, 
    placeholder, 
    onChange, 
    autoComplete,
    theme = {}
}) {
    const {
        textColor = '#000000',
        bgColor = '#FA5813FF',
        // borderColor = '#3f3c3cff',
        placeholderColor = '#a0a0a0'
    } = theme;
    return (
        <div className='flex flex-column gap-2'>
            {label && (
                <label 
                    htmlFor={name} 
                    // className='font-bold' 
                    style={{ 
                      color: '#textColor', 
                      // fontWeight: 'bold' 
                    }}
                >
                    <strong>{label}</strong>
                </label>
            )}
      <input
        type={type}
        id={name}
        name={name}
        value={value ?? ''}
        placeholder={placeholder}
        onChange={onChange}
        autoComplete={autoComplete}
        className='p-inputtext p-component w-full surface-0 h-2rem text-sm'
        style={{
          color: textColor,
          backgroundColor: bgColor,
          // borderColor: borderColor,
          // boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
          '::placeholder': {
            color: placeholderColor
          }
        }}
      />
    </div>
    )
}